
import { defineComponent, ref, computed } from '@vue/composition-api';
import { IconButton } from '@fc/angie-ui';

export default defineComponent({
  name: 'AtfWhatsIncluded',
  components: {
    IconButton,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const isActive = ref(false);

    const iconType = computed(() => (isActive.value ? 'times' : 'plus'));

    function toggleActive() {
      isActive.value = !isActive.value;
    }

    return {
      isActive,
      iconType,
      toggleActive,
    };
  },
});

